<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-school
            </v-icon>
            <span class="title"><b>Detail Data Beasiswa</b></span>
            <v-spacer></v-spacer>
            <v-btn
              :to="{ name: 'SuratGuest' }"
              color="error"
              icon
              x-small>
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <alertsp :alertdata="alertgetdata"></alertsp>
              <div class="text-center" v-if="loading.getdata">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <v-row justify="center" v-if="detaildata">
                <v-col cols="12" md="8" class="px-md-10">
                  <v-row class="black--text">
                    <v-col cols="12" md="12">
                      <div class="title font-weight-bold text-decoration-underline">
                        Data Berkas
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-tabs
                        v-model="tabberkas"
                        show-arrows>
                        <v-tab href="#tab-spdir" class="text-capitalize">
                          Permohonan direktur
                        </v-tab>
                        <v-tab href="#tab-prestasi" class="text-capitalize">
                          Bukti prestasi
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items :touchless="true" v-model="tabberkas">
                        <v-tab-item value="tab-spdir">
                          <v-card flat>
                            <v-card-text>
                              <div>
                                <object
                                  :data="detaildata.urlspdir"
                                  type="application/pdf"
                                  class="pdf-embed-custom">
                                  <p>
                                    Web browser anda tidak memiliki PDF plugin.<br>
                                    Sebaliknya anda dapat download berkaspada tautan berikut:<br>
                                    <a target="_blank" :href="detaildata.urlspdir">
                                      Download
                                    </a>
                                  </p>
                                </object>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-prestasi">
                          <v-card flat>
                            <v-card-text>
                              <div>
                                <object
                                  :data="detaildata.urlprestasi"
                                  type="application/pdf"
                                  class="pdf-embed-custom">
                                  <p>
                                    Web browser anda tidak memiliki PDF plugin.<br>
                                    Sebaliknya anda dapat download berkaspada tautan berikut:<br>
                                    <a target="_blank" :href="detaildata.urlprestasi">
                                      Download
                                    </a>
                                  </p>
                                </object>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-10">
                  <div class="text-right">
                    <v-chip
                      color="red"
                      fab
                      text-color="white">
                      <v-icon left>bookmark</v-icon>
                      {{ detaildata.status_bs }}
                    </v-chip>
                  </div>
                  <v-row class="black--text">
                    <v-col cols="12" md="12">
                      <div class="title font-weight-bold text-decoration-underline">
                        Data Profile
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Periode</span>
                      <h2 class="subtitle-1 font-weight-bold mb-3">
                        {{ detaildata.period_bs }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Beasiswa</span>
                      <h2 class="subtitle-1 font-weight-bold mb-3">
                        {{ detaildata.nama_jb ? detaildata.nama_jb : '-'  }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Status pengajuna</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.status_bs }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Tanggal pengajuan</span>
                      <h2 class="subtitle-1 font-weight-bold mb-3">
                        {{ detaildata.tgl_bs }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">IPK</span>
                      <h2 class="subtitle-1 font-weight-bold mb-3">
                        {{ detaildata.p_ipk }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="title font-weight-bold text-decoration-underline">
                        Data Penilaian
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Penilaian akademik</span>
                      <h2 class="subtitle-1 font-weight-bold mb-3">
                        {{ detaildata.n_akademik }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Penilaian Prestasi</span>
                      <h2 class="subtitle-1 font-weight-bold mb-3">
                        {{ detaildata.n_prestasi }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Penilaian wawancara</span>
                      <h2 class="subtitle-1 font-weight-bold mb-3">
                        {{ detaildata.n_prestasi }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="caption" v-if="false">
                        <p>*SK hanja dapat diakses jika statusnya 'Lulus'</p>
                      </div>
                      <alertsp :alertdata="alertdata"></alertsp>
                      <div class="text-center" v-if="loading.update">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </div>
                      <v-btn
                        v-if="false"
                        large
                        block
                        :disabled="loading.printsurat || (detaildata.status_skm !== 'siap' && detaildata.status_skm !== 'tolak')"
                        color="primary"
                        class="mr-4 mt-5"
                        :loading="loading.printsurat"
                        @click="printSurat">
                        Download
                      </v-btn>
                      <v-btn
                        outlined
                        large
                        block
                        color="primary"
                        class="mr-4 mt-5"
                        :to="{ name: 'SuratGuest' }">
                        Kembali
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'SuratDetailMhs',
  props: ['kodesurat'],
  data: () => ({
    alertgetdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      update: false,
      printsurat: false,
    },
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    baseurl: process.env.VUE_APP_BASEURL,
    liststatus: ['permohonan', 'proses', 'siap', 'selesai', 'batal'],
    listttd: [],
    detaildata: null,
    updatesurat: {
      deskripsi_surat: '',
      status_surat: '',
      kode_surat: '',
      no_surat: '',
      ttd_surat: '',
      ttd_as_surat: '',
      kode_js: '',
      peruntukan_surat: '',
    },
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    canchange: true,
    tabberkas: 'tab-spdir',
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'staticdata',
    ]),
  },
  mounted() {
    if (this.kodesurat) {
      this.getDetailSurat();
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    dateToIndo(value) {
      return getDateTodayId(value);
    },
    kelaminParse(value) {
      return value === 'L' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    printSurat() {
      if (this.tokenscr && this.detaildata.kd_skm && this.detaildata.user_skm) {
        this.loading.printsurat = true;
        this.axios
          .get(
            this.api + '/api/surat/printsurat/' + this.detaildata.kd_skm + '/' + this.detaildata.user_skm,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
              responseType: 'blob',
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.detaildata.kd_skm + '.doc');
              document.body.appendChild(link);
              link.click();
            }
            this.loading.printsurat = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.printsurat = false;
          });
      }
    },
    getTandatangan() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/setting/',
            {
              params: {
                slug: 'tandatangan',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listttd = resdata.data;
                this.updatesurat.ttd_surat = this.updatesurat.ttd_surat ? this.updatesurat.ttd_surat : this.listttd[0];
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    checkCanChange() {
      this.canchange = true;
      const denystatus = ['accbanjar', 'batal', 'selesai'];
      if (denystatus.indexOf(this.updatesurat.status_surat) >= 0) {
        this.canchange = false;
      }
    },
    getDetailSurat() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/beasiswa/' + this.kodesurat,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.detaildata = resdata.data[0];
                  this.detaildata.urlspdir = this.api + '/upload/media/berkas/' + resdata.data[0].f_spdir;
                  this.detaildata.urlprestasi = this.api + '/upload/media/berkas/' + resdata.data[0].f_prestasi;
                } else {
                  this.alertgetdata.show = true;
                  this.alertgetdata.type = 'error';
                  this.alertgetdata.text = 'Data tidak ditemukan!';
                }
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatesurat.validate()) {
        if (this.tokenscr) {
          this.updatesurat.ttd_as_surat = this.updatesurat.ttd_surat.desc_set;
          this.updatesurat.ttd_surat = this.updatesurat.ttd_surat.value_set;
          // console.log(this.updatesurat);
          this.loading.update = true;
          this.axios
            .put(
              this.api + '/api/surat/',
              qs.stringify(
                this.updatesurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kode_surat + '" berhasil diperbaharui!';
                  this.getDetailSurat();
                  this.$root.$emit('app-getnotifiaction');
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.update = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    QrcodeVue,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
